export interface SortableVoice {
    engine?: string;
    styles?: Array<unknown>;
    name: string;
}

const ENGINE_PRIORITY: Record<string, number> = {
    emotional: 3,
    neural: 2,
    standard: 1,
};

// Shared ordering for any voice list shown to a user: engine (emotional > neural >
// standard), then style count (more styles first), then name alphabetically. The Voices
// page (useAIVoicesStore) and the Studio in-editor voice panels must both use this so a
// language's emotional voices surface consistently, regardless of raw JSON array order.
export function sortVoicesInPriority<T extends SortableVoice>(voicesInput: T[] = []): T[] {
    return [...voicesInput].sort((a, b) => {
        const engineDiff = (ENGINE_PRIORITY[b.engine || ''] || 0) - (ENGINE_PRIORITY[a.engine || ''] || 0);
        if (engineDiff !== 0) return engineDiff;

        const stylesDiff = (b.styles?.length || 0) - (a.styles?.length || 0);
        if (stylesDiff !== 0) return stylesDiff;

        return a.name.localeCompare(b.name);
    });
}
